import { Component, OnInit , Inject} from '@angular/core';
import { CommonService } from '../../services/common.service';
import { NgForm } from '@angular/forms';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { AuthService } from '../../authentication/auth.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { MatSnackBar } from '@angular/material';
import { error } from 'util';
@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.css']
})
export class PasswordresetComponent implements OnInit {
  action: any;
  userid: any;
  msg: string;
useremail: any;
oldpasswordflag = 0;
loading = false;
oldpass: any;
np: any;
cnp: any;
  constructor(private commonService: CommonService, public form: FormBuilder,
     private authService: AuthService, private snackBar: MatSnackBar,
      private dialogRef: MatDialogRef < PasswordresetComponent>,
       @Inject(MAT_DIALOG_DATA) public data: any ) {
        this.useremail = this.data.email;
        this.userid = this.data.uid;

      }

  ngOnInit() {
  }
  checkUserPass() {
    this.loading = true;
    this.authService.passwordReset( this.useremail, this.oldpass)
    .subscribe(result => {
                if (result === true) {
                  this.loading = false;
                  this.oldpasswordflag = 1;
                }
            }, (Error) => {
              this.loading = false;
              this.msg = 'You have entered wrong password';
              this.openSnackBar();
            }
          );
  }
  passwordChange() {
    this.loading = true;
    this.authService.changePassword(this.userid , this.np)
    .subscribe(
      (x) => {
        this.loading = false;
        this.msg = 'Password Change Successfully';
        this.openSnackBar();
        this.closeDialog();
      }
    )
  }
  openSnackBar() {
    this.snackBar.open(this.msg , this.action, {
      duration: 4000,
    });
  }


  closeDialog() {
    this.dialogRef.close();
  }
}
